import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import {
    getSpecialdonations,
    deleteSpecialdonation,
    getNextSpecialdonations,
    getPreviousSpecialdonations,
} from "../../store/actions/specialdonations_action";
import { LIMIT } from "../../domain/constant";
import Pagination from "../../components/common/Pagination";
import Filters from "../../components/common/Filters";
import AddBtn from "../../components/common/AddBtn";
import { SEARCH_TERMS, view_all_table } from "../../shared/enums/specialdonations_enum";
import DataTable from "../../components/common/DataTable";
const AllSpecialdonations = ({
    getSpecialdonations,
    deleteSpecialdonation,
    getNextSpecialdonations,
    getPreviousSpecialdonations,
    specialdonation: { loading, specialdonations },
}) => {
    const [page, setPage] = useState(1);
    const [deleteEntry, setDeleteEntry] = useState(null);
    const [q, setQ] = useState(null);
    const [term, setTerm] = useState(null);
    const [termField, setTermField] = useState(SEARCH_TERMS[0]);
    useEffect(() => {
        async function allQuery() {
            if (deleteEntry) {
                await deleteSpecialdonation(deleteEntry);
            }
            getSpecialdonations({});
        }
        allQuery();
    }, [deleteEntry]);

    const nextButtonClicked = () => {
        if (specialdonations && specialdonations.length === LIMIT) {
            const lastSpecialdonation = specialdonations[specialdonations.length - 1];
            getNextSpecialdonations({ last: lastSpecialdonation });
            setPage(page + 1);
        }
    };
    const prevBtnClicked = () => {
        if (page > 1) {
            const lastSpecialdonation = specialdonations[0];
            getPreviousSpecialdonations({
                first: lastSpecialdonation,
            });
            setPage(page - 1);
        }
    };
    const filterClicked = () => {
        if (term && term.length > 0) {
            setPage(1);
            setQ(term);
            getSpecialdonations({ term: term, termField: termField });
        }
    };
    const deleteSpecialdonationClicked = (id) => {
        setDeleteEntry(id);
    };
    const resetFilter = () => {
        setPage(1);
        setQ(null);
        setTerm("");
        getSpecialdonations({});
    };

    return (
        <div className="pace-done">
            <div>
                <Header />
                <BreadCrumb
                    title="Specialdonations"
                    mainLinkTitle="Dashboard"
                    mainLinkUrl="/dashboard"
                    activeLink="Specialdonation"
                />

                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-12">
                            <div
                                className="card"
                                style={{ boxShadow: "rgb(227 233 243) 0px 4px 22px" }}
                            >
                                <div className="card-body">
                                    <AddBtn item="specialdonations" title="Specialdonation" />
                                    <hr />

                                    <Filters
                                        q={q}
                                        resetFilter={resetFilter}
                                        setTerm={setTerm}
                                        term={term}
                                        filterClicked={filterClicked}
                                        termField={termField}
                                        setTermField={setTermField}
                                        all_terms={SEARCH_TERMS}
                                    />
                                    <hr />
                                    <div>
                                        <DataTable
                                            keys={view_all_table}
                                            data={specialdonations}
                                            field={"specialdonations"}
                                            page={page}
                                            deleteBtnClicked={deleteSpecialdonationClicked}
                                            loading={loading}
                                        />
                                        <Pagination
                                            data={specialdonations}
                                            page={page}
                                            prevBtnClicked={prevBtnClicked}
                                            nextButtonClicked={nextButtonClicked}
                                            loading={loading}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({ specialdonation: state.specialdonation });

const mapDispatchToProps = {
    getSpecialdonations,
    deleteSpecialdonation,
    getNextSpecialdonations,
    getPreviousSpecialdonations,
};

export default connect(mapStateToProps, mapDispatchToProps)(AllSpecialdonations);
